var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUmpireSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 153,
    viewBox: "0 0 167 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9854",
    "data-name": "Group 9854",
    transform: "translate(-970 -477)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17594",
    "data-name": "Rectangle 17594",
    width: 167,
    height: 153,
    rx: 10,
    transform: "translate(970 477)",
    fill: "#020e72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "referee-svgrepo-com",
    transform: "translate(1025 505.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9789",
    "data-name": "Group 9789",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80154",
    "data-name": "Path 80154",
    d: "M355.236,469.4a.334.334,0,0,0-.336.336V505.33a.479.479,0,0,0,.481.481h2.643a.479.479,0,0,0,.481-.481V469.736a.334.334,0,0,0-.336-.336Z",
    transform: "translate(-330.412 -433.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80155",
    "data-name": "Path 80155",
    d: "M450.736,469.4a.334.334,0,0,0-.336.336V505.33a.479.479,0,0,0,.481.481h2.643a.479.479,0,0,0,.481-.481V469.736a.334.334,0,0,0-.336-.336Z",
    transform: "translate(-418.618 -433.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80156",
    "data-name": "Path 80156",
    d: "M35.27,147.207l16.01,13.306a1.31,1.31,0,0,1,.474,1.008v24.2a.427.427,0,0,0,.428.428h2.75a.427.427,0,0,0,.428-.428V149.736a1.028,1.028,0,0,0-.428-.832l-10.907-7.982a1.056,1.056,0,0,1-.428-.848V123.965a.679.679,0,0,0-.519-.657l-8.028-.008a.686.686,0,0,0-.55.665v21.578A2.155,2.155,0,0,0,35.27,147.207Z",
    transform: "translate(-34.483 -113.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80157",
    "data-name": "Path 80157",
    d: "M544.336,469.4a.334.334,0,0,0-.336.336V505.33a.479.479,0,0,0,.481.481h2.643a.479.479,0,0,0,.481-.481V469.736a.334.334,0,0,0-.336-.336Z",
    transform: "translate(-505.068 -433.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80158",
    "data-name": "Path 80158",
    d: "M638.5,185.719a.427.427,0,0,0,.428.428h2.75a.427.427,0,0,0,.428-.428v-24.2a1.322,1.322,0,0,1,.474-1.008l15.979-13.275a2.241,2.241,0,0,0,.817-1.734v-21.54a.68.68,0,0,0-.55-.665l-8.028.008a.686.686,0,0,0-.519.657v16.109a1.056,1.056,0,0,1-.428.848L638.927,148.9a1.06,1.06,0,0,0-.428.832C638.5,153.929,638.5,181.908,638.5,185.719Z",
    transform: "translate(-592.349 -113.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80159",
    "data-name": "Path 80159",
    d: "M793.044,7.974h2.429a.113.113,0,0,0,.053-.008.343.343,0,0,0,.084.008h5.706a.592.592,0,0,0,.565-.619V3.216a3.42,3.42,0,0,0-6.828,0V4.323a1.336,1.336,0,0,0-.794-.26A1.53,1.53,0,0,0,792.8,5.652V7.715A.26.26,0,0,0,793.044,7.974Z",
    transform: "translate(-734.865 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80160",
    "data-name": "Path 80160",
    d: "M34.873,7.974h5.706a.286.286,0,0,0,.084-.008.13.13,0,0,0,.053.008h2.429a.249.249,0,0,0,.237-.26V5.652a1.525,1.525,0,0,0-1.459-1.589,1.372,1.372,0,0,0-.794.26V3.216A3.148,3.148,0,0,0,37.714,0,3.148,3.148,0,0,0,34.3,3.216V7.363A.6.6,0,0,0,34.873,7.974Z",
    transform: "translate(-34.3 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80161",
    "data-name": "Path 80161",
    d: "M307.025,83.9c.458.115,1.062.244,1.787.39a10.379,10.379,0,0,0,20.715,0c.726-.145,1.329-.275,1.787-.39a.868.868,0,0,0,.565-1.245l-1.833-3.483v-.061a10.884,10.884,0,0,0-9.189-10.747,1.808,1.808,0,0,0-3.376,0,10.877,10.877,0,0,0-9.189,10.747v.061l-1.833,3.483A.874.874,0,0,0,307.025,83.9Zm6.775-9.158a1.407,1.407,0,0,1,.252-.023h10.105a1.586,1.586,0,0,1,.5.084,1.54,1.54,0,0,1,.665.451,1.585,1.585,0,0,1,.344.71l.412,2.085a1.033,1.033,0,0,1-1.016,1.23H313.135a.26.26,0,0,1-.076-.008.99.99,0,0,1-.4-.107,1.031,1.031,0,0,1-.542-1.123l.412-2.085a1.331,1.331,0,0,1,.176-.458A1.551,1.551,0,0,1,313.8,74.738Z",
    transform: "translate(-285.584 -62.066)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmpireSelected);
export default __webpack_public_path__ + "static/media/umpire-selected.996181398438b8160690c8e0a697ca5b.svg";
export { ForwardRef as ReactComponent };